import { ALL_POLICY_DOCUMENTS_NAMES } from "@consts/index";

export const isDocumentFromSocotra = (fileName: string) =>
  ALL_POLICY_DOCUMENTS_NAMES.some((name) => fileName.startsWith(name));
